import React, { Component } from "react";
import {
  Table, Button, Modal, Col, Row, message, Tooltip, Tabs, Upload,
  Select, Alert, Tag, Spin, Divider, Input
} from "antd";
import axios from "axios";
import "./Pages.css";
import CompraForm from '../components/CompraForm';
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import CompraPrintModal from "../relatorios/CompraPrintModal";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import Compras from '../tutoriais/LancCompras';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { TabPane } = Tabs;
const { Option } = Select;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalCompras: 0,
    qtdeCompras: 0,
    formFiltroVisivel: false,
    formPrintVisivel: false,
    idfCompra: 0,

    // Importacao de NF-e de compra
    importacaoVisivel: false,
    importacaoAba: 'xml',
    xmlArquivo: null,
    importandoXml: false,
    consultandoSefaz: false,
    carregandoEmitentesNFe: false,
    emitentesNFe: [],
    emitenteNFeSelecionado: null,
    chaveConsultaSefaz: '',
    notaImportacao: null,
    notasSefaz: [],
    resumosSefaz: [],
    retornoSefaz: null,
    produtosImportacao: [],
    buscandoProdutosImportacao: false,

    filtros: {
      tipoTela: 'COM',
      buscaOrdem: { campo: 'com_dt_compra', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0' },
      buscaProduto: { key: '0' },
      buscaGrupoProduto: { key: '0' },
      buscaMarcaProduto: { key: '0' },
      buscaServico: { key: '0' },
      buscaUsuario: { key: '0' },
      buscaSitFin: { key: 'X', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalCompras: 0, qtdeCompras: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaSitFin, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/compras', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          pessoa: buscaPessoa.key,
          usuario: buscaUsuario.key,
          sitFin: String(buscaSitFin.key),
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalCompras: response.data.totalCompras,
          qtdeCompras: response.data.qtdeCompras,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.com_idf) {
      request = axios.put(`/compras/update/${registro.com_idf}`, registro);
    } else {
      request = axios.post(`/compras/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Compra gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }

  onAdicionarClick = () => {
    axios.get(`/caixas/caixaAberto`, { params: { id: 0, cta: 0, data: '', situacao: 'X', } })
      .then(response => {
        const { data } = response;

        // console.log('onAdicionarClick', data)

        this.setState({
          formVisivel: true,
          visualizar: false,
          registroSelecionado: {
            dados: {
              com_idf: 0,
              com_numero: '',
              com_dt_compra: data && data.cx_data ? moment(data.cx_data).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'),
              com_obs: '',
              com_qtde_itens: 0,
              com_vlr_itens: 0,
              com_vlr_acres: 0,
              com_vlr_desc: 0,
              com_vlr_total: 0,
              com_pessoa: { key: '0' },
              com_tipo_doc: { key: '0' },
              com_cond_pagto: { key: '0' },
              listaProdutos: [],
              visualizando: false,
            }
          },
          registroParcela: {
            tparc_parcela: 0,
            tparc_data_parcela: '',
            tparc_tipo_doc: { key: '0' },
            tparc_conta_corrente: { key: '0' },
            tparc_valor: 0,
            tparc_situacao: { key: 'A', label: 'ABERTO', },
            tparc_obs: '',
            td_descricao: '',
            cc_descricao: '',
            situacao_parcela: '',
            pgto_vlr_desconto: 0,
            pgto_vlr_acrescimo: 0,
            pgto_vlr_pago: 0,
            pgto_vlr_restante: 0,
            pgto_data: '',
            pgto_cta_corrente: '',
          },
        })

      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/compras/show/${registro.com_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.nfe_chave = data.dados.nfe_chave || data.dados.com_nfe_chave || '';

        data.dados.com_pessoa = {
          key: String(data.dados.com_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.com_cond_pagto = {
          key: data.dados.com_cond_pagto ? String(data.dados.com_cond_pagto) : '',
          label: data.dados.cp_descricao,
          qtdeParc: data.dados.cp_qtde_parc,
          parcAVista: data.dados.cp_parc_avista,
        }
        data.dados.com_tipo_doc = {
          key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tparc_tipo_doc) ? String(data.listaParcelas[0].tparc_tipo_doc) : '',
          label: (data.listaParcelas.length > 0 && data.listaParcelas[0].td_descricao) ? String(data.listaParcelas[0].td_descricao) : '',
        }

        data.dados.com_dt_compra = moment(data.dados.com_dt_compra, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.visualizando = false;

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/compras/delete/${registro.com_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.com_idf === registro.com_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };

  onImprimirClick = (com_idf) => {
    this.setState({
      idfCompra: com_idf,
      formPrintVisivel: true,
    });
  };

  onCancelarPrintClick = () => {
    this.setState({
      idfCompra: 0,
      formPrintVisivel: false
    })
  }



  // ---------------------------------------------------------------------------------------
  // IMPORTACAO NF-e DE COMPRA
  // ---------------------------------------------------------------------------------------

  onAbrirImportacaoNFe = () => {
    this.setState({
      importacaoVisivel: true,
      importacaoAba: 'xml',
      xmlArquivo: null,
      importandoXml: false,
      consultandoSefaz: false,
      carregandoEmitentesNFe: false,
      emitentesNFe: [],
      emitenteNFeSelecionado: null,
      chaveConsultaSefaz: '',
      notaImportacao: null,
      notasSefaz: [],
      resumosSefaz: [],
      retornoSefaz: null,
      produtosImportacao: [],
    }, this.carregarEmitentesImportacaoNFe);
  };

  onFecharImportacaoNFe = () => {
    this.setState({
      importacaoVisivel: false,
      xmlArquivo: null,
      notaImportacao: null,
      notasSefaz: [],
      resumosSefaz: [],
      retornoSefaz: null,
      produtosImportacao: [],
      emitentesNFe: [],
      emitenteNFeSelecionado: null,
      chaveConsultaSefaz: '',
      carregandoEmitentesNFe: false,
    });
  };

  getMensagemErro = (error, fallback) => {
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      if (typeof data === 'string') return data;
      if (data.mensagem) {
        return data.xMotivo ? `${data.mensagem} ${data.xMotivo}` : data.mensagem;
      }
      if (typeof data === 'object') {
        const primeira = Object.keys(data)[0];
        if (primeira && Array.isArray(data[primeira])) return data[primeira][0];
        return JSON.stringify(data);
      }
    }
    return fallback;
  };

  exibirAvisosNFeImportacao = nota => {
    if (!nota) return;

    const avisos = [];
    const destinatario = nota.destinatario || {};

    if (destinatario.documento && !destinatario.emitente_localizado) {
      avisos.push(
        `O destinatário do XML (${destinatario.nome || 'sem nome'} - ${destinatario.documento}) não corresponde a nenhum CNPJ/CPF de emitente cadastrado para esta empresa.`
      );
    }

    if (nota.ja_cadastrada) {
      const compra = nota.compra_existente || {};
      let texto = `A NF-e de chave ${nota.chave || ''} já foi localizada nas compras do FastGestor.`;
      if (compra.com_numero) texto += ` Compra nº ${compra.com_numero}.`;
      if (compra.pes_nome) texto += ` Fornecedor: ${compra.pes_nome}.`;
      avisos.push(texto);
    }

    if (avisos.length > 0) {
      Modal.warning({
        title: avisos.length > 1 ? 'Atenção ao importar esta NF-e' : 'Atenção',
        content: (
          <div>
            {avisos.map((aviso, index) => (
              <div key={index} style={{ marginBottom: index < avisos.length - 1 ? 10 : 0 }}>
                {aviso}
              </div>
            ))}
            <div style={{ marginTop: 12, fontWeight: 'bold' }}>
              A importação continuará liberada para conferência.
            </div>
          </div>
        ),
        okText: 'Continuar conferindo',
      });
    }
  };

  carregarEmitentesImportacaoNFe = () => {
    this.setState({ carregandoEmitentesNFe: true });

    axios.get('/compras/importacao/emitentes')
      .then(response => {
        const data = response.data || {};
        const emitentes = Array.isArray(data.emitentes) ? data.emitentes : [];
        const padrao = data.emitentePadrao
          ? Number(data.emitentePadrao)
          : (emitentes.length === 1 ? Number(emitentes[0].enf_idf) : null);

        this.setState({
          carregandoEmitentesNFe: false,
          emitentesNFe: emitentes,
          emitenteNFeSelecionado: padrao,
        });
      })
      .catch(error => {
        this.setState({
          carregandoEmitentesNFe: false,
          emitentesNFe: [],
          emitenteNFeSelecionado: null,
        });
        Modal.error({
          title: 'Emitentes NF-e',
          content: this.getMensagemErro(
            error,
            'Não foi possível carregar os emitentes da empresa.'
          ),
          okText: 'OK',
        });
      });
  };

  onSelecionarEmitenteNFe = emitente => {
    this.setState({
      emitenteNFeSelecionado: Number(emitente),
      chaveConsultaSefaz: '',
      notaImportacao: null,
      notasSefaz: [],
      resumosSefaz: [],
      retornoSefaz: null,
      produtosImportacao: [],
    });
  };

  onLerXmlNFe = () => {
    const { xmlArquivo } = this.state;
    if (!xmlArquivo) {
      message.warning('Selecione o arquivo XML da NF-e.');
      return;
    }

    const formData = new FormData();
    formData.append('arquivo', xmlArquivo);

    this.setState({ importandoXml: true, notaImportacao: null, produtosImportacao: [] });
    axios.post('/compras/importacao/xml', formData)
      .then(response => {
        const nota = response.data;
        this.setState({
          importandoXml: false,
          notaImportacao: nota,
        }, () => this.exibirAvisosNFeImportacao(nota));
      })
      .catch(error => {
        this.setState({ importandoXml: false });
        Modal.error({
          title: 'Falha ao ler XML',
          content: this.getMensagemErro(error, 'Não foi possível ler o XML da NF-e.'),
          okText: 'OK',
        });
      });
  };

  onConsultarSefazNFe = () => {
    const { emitenteNFeSelecionado } = this.state;

    if (!emitenteNFeSelecionado) {
      message.warning('Selecione o emitente que será usado na consulta da SEFAZ.');
      return;
    }

    this.setState({
      consultandoSefaz: true,
      notaImportacao: null,
      notasSefaz: [],
      resumosSefaz: [],
      retornoSefaz: null,
      produtosImportacao: [],
    });

    axios.get('/compras/importacao/sefaz', {
      params: {
        emitente: emitenteNFeSelecionado,
      }
    })
      .then(response => {
        const data = response.data || {};
        const notas = Array.isArray(data.notas) ? data.notas : [];
        const notaUnica = notas.length === 1 ? notas[0] : null;
        this.setState({
          consultandoSefaz: false,
          notasSefaz: notas,
          resumosSefaz: Array.isArray(data.resumos) ? data.resumos : [],
          retornoSefaz: data,
          notaImportacao: notaUnica,
        }, () => {
          if (notaUnica) this.exibirAvisosNFeImportacao(notaUnica);
        });

        if (notas.length === 0 && (!data.resumos || data.resumos.length === 0)) {
          message.info(data.xMotivo || 'Nenhuma NF-e disponível nesta consulta.');
        }
      })
      .catch(error => {
        this.setState({ consultandoSefaz: false });
        Modal.error({
          title: 'Consulta SEFAZ',
          content: this.getMensagemErro(error, 'Não foi possível consultar a distribuição de DF-e.'),
          okText: 'OK',
        });
      });
  };

  onConsultarSefazPorChave = () => {
    const { emitenteNFeSelecionado, chaveConsultaSefaz } = this.state;
    const chave = String(chaveConsultaSefaz || '').replace(/\D/g, '');

    if (!emitenteNFeSelecionado) {
      message.warning('Selecione o emitente que será usado na consulta da SEFAZ.');
      return;
    }

    if (chave.length !== 44) {
      message.warning('Informe uma chave de acesso de NF-e com 44 dígitos.');
      return;
    }

    this.setState({
      consultandoSefaz: true,
      notaImportacao: null,
      notasSefaz: [],
      resumosSefaz: [],
      retornoSefaz: null,
      produtosImportacao: [],
    });

    axios.get('/compras/importacao/sefaz', {
      params: {
        emitente: emitenteNFeSelecionado,
        chave,
      }
    })
      .then(response => {
        const data = response.data || {};
        const notas = Array.isArray(data.notas) ? data.notas : [];
        const notaUnica = notas.length === 1 ? notas[0] : null;

        this.setState({
          consultandoSefaz: false,
          notasSefaz: notas,
          resumosSefaz: Array.isArray(data.resumos) ? data.resumos : [],
          retornoSefaz: data,
          notaImportacao: notaUnica,
        }, () => {
          if (notaUnica) this.exibirAvisosNFeImportacao(notaUnica);
        });

        if (notas.length === 0 && (!data.resumos || data.resumos.length === 0)) {
          message.info(data.xMotivo || 'NF-e não localizada para a chave informada.');
        }
      })
      .catch(error => {
        this.setState({ consultandoSefaz: false });
        Modal.error({
          title: 'Consulta por chave - SEFAZ',
          content: this.getMensagemErro(error, 'Não foi possível consultar a NF-e pela chave de acesso.'),
          okText: 'OK',
        });
      });
  };

  onSelecionarNotaSefaz = chave => {
    const nota = (this.state.notasSefaz || []).find(item => item.chave === chave);
    this.setState({ notaImportacao: nota || null, produtosImportacao: [] }, () => {
      if (nota) this.exibirAvisosNFeImportacao(nota);
    });
  };

  onBuscarProdutoImportacao = busca => {
    const texto = String(busca || '').trim();
    if (texto.length < 2) return;

    if (this.buscaProdutoImportacaoTimer) {
      clearTimeout(this.buscaProdutoImportacaoTimer);
    }

    this.buscaProdutoImportacaoTimer = setTimeout(() => {
      this.setState({ buscandoProdutosImportacao: true });
      axios.get('/compras/importacao/produtos', { params: { busca: texto } })
        .then(response => {
          this.setState({
            produtosImportacao: Array.isArray(response.data) ? response.data : [],
            buscandoProdutosImportacao: false,
          });
        })
        .catch(() => {
          this.setState({ buscandoProdutosImportacao: false });
        });
    }, 300);
  };

  onVincularProdutoImportacao = (indice, prodId) => {
    const { notaImportacao, produtosImportacao } = this.state;
    if (!notaImportacao) return;

    const produto = (produtosImportacao || []).find(item => String(item.prod_idf) === String(prodId));
    if (!produto) return;

    const itens = [...(notaImportacao.itens || [])];
    itens[indice] = {
      ...itens[indice],
      prod_idf: produto.prod_idf,
      prod_codigo: produto.prod_codigo,
      prod_descricao: produto.prod_descricao,
      prod_cod_barras: produto.prod_cod_barras,
      prod_grade: Number(produto.prod_grade || 0),
      mi_item_tamanho: Number(produto.mi_item_tamanho || 1),
      mi_item_cor: Number(produto.mi_item_cor || 1),
      qtde_variacoes: Number(produto.qtde_variacoes || 0),
      vinculo_origem: 'MANUAL',
      localizado: true,
    };

    this.setState({
      notaImportacao: {
        ...notaImportacao,
        itens,
        itensNaoLocalizados: itens.filter(item => !item.prod_idf).length,
      }
    });
  };

  onConfirmarImportacaoNFe = () => {
    const { notaImportacao } = this.state;
    if (!notaImportacao) return;

    const pendentes = (notaImportacao.itens || []).filter(item => !item.prod_idf);
    if (pendentes.length > 0) {
      Modal.warning({
        title: 'Itens sem vínculo',
        content: `Ainda existem ${pendentes.length} item(ns) sem produto do FastGestor. Selecione o produto na lista antes de continuar.`,
        okText: 'OK',
      });
      return;
    }

    this.setState({ importandoXml: true });

    axios.post('/compras/importacao/vinculos', {
      fornecedor_idf: notaImportacao.fornecedor && notaImportacao.fornecedor.pes_idf
        ? notaImportacao.fornecedor.pes_idf
        : null,
      fornecedor: notaImportacao.fornecedor || {},
      itens: (notaImportacao.itens || []).map(item => ({
        prod_idf: item.prod_idf,
        cProd: item.cProd || '',
        cEAN: item.cEAN || '',
      })),
    }).then(response => {
      const retorno = response.data || {};
      const fornecedor = retorno.fornecedor || notaImportacao.fornecedor || {};
      const notaAtualizada = {
        ...notaImportacao,
        fornecedor: {
          ...(notaImportacao.fornecedor || {}),
          ...fornecedor,
          documento: fornecedor.pes_cpf_cnpj
            || (notaImportacao.fornecedor && notaImportacao.fornecedor.documento)
            || '',
          localizado: true,
        },
      };

      this.setState({
        importandoXml: false,
        notaImportacao: notaAtualizada,
      }, () => this.onPrepararCompraImportada(retorno.financeiro || {}));
    }).catch(error => {
      this.setState({ importandoXml: false });
      Modal.error({
        title: 'Preparação da importação',
        content: this.getMensagemErro(error, 'Não foi possível preparar o fornecedor e os vínculos dos produtos.'),
        okText: 'OK',
      });
    });
  };

  montarParcelasImportacaoNFe = (financeiro, valorTotal, dataCompra) => {
    const condId = Number(financeiro.par_cond_pagto_padrao || 0);
    const docId = Number(financeiro.par_doc_padrao || 0);
    const contaId = Number(financeiro.par_cta_corrente_padrao || 0);

    if (!condId || !docId || !contaId || Number(valorTotal || 0) <= 0) {
      return [];
    }

    let prazos = String(financeiro.cp_parcelas || '')
      .split(',')
      .map(item => parseInt(String(item).trim(), 10))
      .filter(item => !Number.isNaN(item) && item >= 0);

    if (!prazos.length) {
      const qtde = parseInt(financeiro.cp_qtde_parc || 0, 10);
      if (qtde > 0) {
        prazos = Array.from({ length: qtde }, (_, index) => {
          if (Number(financeiro.cp_parc_avista || 0) === 1 && index === 0) return 0;
          return (index + 1) * 30;
        });
      } else if (Number(financeiro.cp_parc_avista || 0) === 1) {
        prazos = [0];
      }
    }

    if (!prazos.length) return [];

    const emissao = moment(dataCompra, 'DD/MM/YYYY').isValid()
      ? moment(dataCompra, 'DD/MM/YYYY')
      : moment();

    const total = Number(valorTotal || 0);
    const valorBase = Number((total / prazos.length).toFixed(2));
    let acumulado = 0;

    return prazos.map((prazo, index) => {
      const ultima = index === prazos.length - 1;
      const valor = ultima ? Number((total - acumulado).toFixed(2)) : valorBase;
      acumulado = Number((acumulado + valor).toFixed(2));

      return {
        tparc_parcela: index + 1,
        tparc_data_parcela: emissao.clone().add(Number(prazo || 0), 'days').format('YYYY-MM-DD'),
        tparc_tipo_doc: docId,
        tparc_conta_corrente: contaId,
        tparc_valor: valor,
        tparc_situacao: 'A',
        tparc_obs: '',
        td_descricao: financeiro.td_descricao || '',
        cc_descricao: financeiro.cc_descricao || '',
        cx_situacao: 1,
        situacao_titulo: 'ABERTO',
        situacao_parcela: 'ABERTO',
        pgto_data: '',
        pgto_cta_corrente: contaId,
        pgto_desc_cta_corrente: financeiro.cc_descricao || '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: valor,
      };
    });
  };

  onPrepararCompraImportada = (financeiro = {}) => {
    const { notaImportacao } = this.state;
    if (!notaImportacao) return;

    if (!notaImportacao.fornecedor || !notaImportacao.fornecedor.pes_idf) {
      Modal.warning({
        title: 'Fornecedor não preparado',
        content: 'Não foi possível identificar ou cadastrar o fornecedor da NF-e.',
        okText: 'OK',
      });
      return;
    }

    const pendentes = (notaImportacao.itens || []).filter(item => !item.prod_idf);
    if (pendentes.length > 0) {
      Modal.warning({
        title: 'Itens sem vínculo',
        content: `Ainda existem ${pendentes.length} item(ns) sem produto do FastGestor. Selecione o produto na lista antes de continuar.`,
        okText: 'OK',
      });
      return;
    }

    const listaProdutos = (notaImportacao.itens || []).map(item => ({
      prod_idf: Number(item.prod_idf),
      prod_codigo: item.prod_codigo,
      prod_descricao: item.prod_descricao,
      prod_cod_barras: item.prod_cod_barras,
      prod_grade: Number(item.prod_grade || 0),
      mi_item_tamanho: Number(item.mi_item_tamanho || 1),
      mi_item_cor: Number(item.mi_item_cor || 1),
      mi_qtde: Number(item.qCom || 0),
      mi_vlr_unit: Number(item.vUnCom || 0),
      mi_perc_desc: 0,
      mi_vlr_desc: Number(item.vDesc || 0),
      mi_vlr_acres: Number(item.vAcres || 0),
      mi_vlr_total: Number(item.vTotal || 0),
      pfi_cod_item_fornecedor: item.cProd || '',
      pfi_cod_barras_fornecedor: item.cEAN || '',
      nfe_ncm: item.NCM || '',
      nfe_cfop: item.CFOP || '',
      nfe_descricao_fornecedor: item.xProd || '',
    }));

    const dataCompra = notaImportacao.dataEmissao
      ? moment(notaImportacao.dataEmissao).format('DD/MM/YYYY')
      : moment().format('DD/MM/YYYY');

    const valorTotal = Number(notaImportacao.totais && notaImportacao.totais.vNF || 0);
    const listaParcelas = this.montarParcelasImportacaoNFe(financeiro, valorTotal, dataCompra);

    const obsNFe = `NF-e ${notaImportacao.numero || ''} Série ${notaImportacao.serie || ''} Chave ${notaImportacao.chave || ''}`.trim();
    const dados = {
      com_idf: 0,
      com_numero: String(notaImportacao.numero || ''),
      com_dt_compra: dataCompra,
      com_obs: obsNFe.substring(0, 200),
      com_qtde_itens: listaProdutos.length,
      com_vlr_itens: Number(notaImportacao.totais && notaImportacao.totais.vProd || 0),
      com_vlr_acres: Number((notaImportacao.totais && notaImportacao.totais.vFrete || 0) + (notaImportacao.totais && notaImportacao.totais.vOutro || 0)),
      com_vlr_desc: Number(notaImportacao.totais && notaImportacao.totais.vDesc || 0),
      com_vlr_total: valorTotal,
      com_pessoa: {
        key: String(notaImportacao.fornecedor.pes_idf),
        label: notaImportacao.fornecedor.pes_nome,
      },
      com_tipo_doc: {
        key: financeiro.par_doc_padrao ? String(financeiro.par_doc_padrao) : '0',
        label: financeiro.td_descricao || '',
      },
      com_cond_pagto: {
        key: financeiro.par_cond_pagto_padrao ? String(financeiro.par_cond_pagto_padrao) : '0',
        label: financeiro.cp_descricao || '',
        qtdeParc: Number(financeiro.cp_qtde_parc || 0),
        parcAVista: Number(financeiro.cp_parc_avista || 0),
        cp_parcelas: financeiro.cp_parcelas || '',
      },
      com_tipo_compra: 'P',
      origem_importacao_nfe: 1,
      nfe_chave: notaImportacao.chave || '',
      nfe_numero: notaImportacao.numero || '',
      nfe_serie: notaImportacao.serie || '',
      listaProdutos,
      visualizando: false,
    };

    this.setState({
      importacaoVisivel: false,
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados,
        listaProdutos,
        listaParcelas,
        visualizar: false,
      },
      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: '',
        tparc_tipo_doc: {
          key: financeiro.par_doc_padrao ? String(financeiro.par_doc_padrao) : '0',
          label: financeiro.td_descricao || '',
        },
        tparc_conta_corrente: {
          key: financeiro.par_cta_corrente_padrao ? String(financeiro.par_cta_corrente_padrao) : '0',
          label: financeiro.cc_descricao || '',
        },
        tparc_valor: 0,
        tparc_situacao: { key: 'A', label: 'ABERTO' },
        tparc_obs: '',
        td_descricao: financeiro.td_descricao || '',
        cc_descricao: financeiro.cc_descricao || '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: '',
        pgto_cta_corrente: financeiro.par_cta_corrente_padrao || '',
      },
    });

    if (!financeiro.par_pc_compra || !financeiro.par_cta_corrente_padrao
      || !financeiro.par_doc_padrao || !financeiro.par_cond_pagto_padrao) {
      message.warning('A compra foi preparada, mas existem parâmetros financeiros padrão não configurados. Confira o financeiro antes de salvar.');
    }
  };

  renderStatusVinculo = item => {
    if (!item.prod_idf) {
      return <Tag color="red">Não localizado</Tag>;
    }
    if (item.vinculo_origem === 'COD_ITEM_FORNECEDOR') {
      return <Tag color="green">Vínculo fornecedor</Tag>;
    }
    if (item.vinculo_origem === 'COD_BARRAS') {
      return <Tag color="blue">Código de barras</Tag>;
    }
    return <Tag color="gold">Selecionado manualmente</Tag>;
  };

  renderImportacaoNFeModal = () => {
    const {
      importacaoVisivel, importacaoAba, xmlArquivo, importandoXml, consultandoSefaz,
      carregandoEmitentesNFe, emitentesNFe, emitenteNFeSelecionado, chaveConsultaSefaz,
      notaImportacao, notasSefaz, resumosSefaz, retornoSefaz,
      produtosImportacao, buscandoProdutosImportacao,
    } = this.state;

    const itens = notaImportacao && Array.isArray(notaImportacao.itens) ? notaImportacao.itens : [];
    const todosVinculados = itens.length > 0 && itens.every(item => !!item.prod_idf);
    const fornecedorOk = !!(notaImportacao && notaImportacao.fornecedor && notaImportacao.fornecedor.pes_idf);
    const emitenteSelecionado = (emitentesNFe || []).find(
      item => String(item.enf_idf) === String(emitenteNFeSelecionado)
    );

    return (
      <Modal
        title="Importar NF-e de Compra"
        visible={importacaoVisivel}
        onCancel={this.onFecharImportacaoNFe}
        width="92%"
        style={{ top: 20 }}
        footer={[
          <Button key="cancelar" onClick={this.onFecharImportacaoNFe}>Cancelar</Button>,
          <Button
            key="continuar"
            type="primary"
            disabled={!notaImportacao || !todosVinculados}
            onClick={this.onConfirmarImportacaoNFe}
            loading={importandoXml}
          >
            {fornecedorOk ? 'Continuar para a Compra' : 'Cadastrar Fornecedor e Continuar'}
          </Button>
        ]}
      >
        <Tabs
          activeKey={importacaoAba}
          onChange={key => {
            this.setState({
              importacaoAba: key,
              notaImportacao: null,
              produtosImportacao: [],
              notasSefaz: key === 'sefaz' ? this.state.notasSefaz : [],
              resumosSefaz: key === 'sefaz' ? this.state.resumosSefaz : [],
              retornoSefaz: key === 'sefaz' ? this.state.retornoSefaz : null,
            });
            if (key === 'sefaz' && (!this.state.emitentesNFe || this.state.emitentesNFe.length === 0)) {
              this.carregarEmitentesImportacaoNFe();
            }
          }}
        >
          <TabPane tab="Arquivo XML" key="xml">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
              <Upload
                accept=".xml,text/xml,application/xml"
                fileList={xmlArquivo ? [xmlArquivo] : []}
                beforeUpload={file => {
                  this.setState({ xmlArquivo: file, notaImportacao: null });
                  return false;
                }}
                onRemove={() => {
                  this.setState({ xmlArquivo: null, notaImportacao: null });
                  return true;
                }}
              >
                <Button icon="folder-open">Escolher XML</Button>
              </Upload>
              <Button
                type="primary"
                icon="file-search"
                loading={importandoXml}
                disabled={!xmlArquivo}
                onClick={this.onLerXmlNFe}
              >
                Ler XML
              </Button>
            </div>
          </TabPane>

          <TabPane tab="SEFAZ - Distribuição DF-e" key="sefaz">
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 12 }}
              message="Consulta oficial NFeDistribuicaoDFe"
              description="Selecione o emitente/CNPJ da empresa. Você pode consultar a distribuição sequencial por NSU ou buscar pontualmente uma NF-e informando a chave de acesso de 44 dígitos."
            />

            <Row gutter={12} style={{ marginBottom: 12 }}>
              <Col xs={24} md={16}>
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Emitente da empresa</div>
                <Select
                  style={{ width: '100%' }}
                  placeholder="Selecione o emitente"
                  value={emitenteNFeSelecionado || undefined}
                  onChange={this.onSelecionarEmitenteNFe}
                  loading={carregandoEmitentesNFe}
                  showSearch
                  optionFilterProp="children"
                  notFoundContent={carregandoEmitentesNFe ? <Spin size="small" /> : 'Nenhum emitente ativo'}
                >
                  {(emitentesNFe || []).map(emitente => (
                    <Option key={emitente.enf_idf} value={Number(emitente.enf_idf)}>
                      {`${emitente.enf_razao_social || 'Emitente'} - ${emitente.enf_cnpj || ''}${Number(emitente.enf_emissao_padrao) === 1 ? ' - PADRÃO' : ''}`}
                    </Option>
                  ))}
                </Select>
              </Col>

              <Col xs={24} md={8} style={{ paddingTop: 24 }}>
                <Button
                  type="primary"
                  icon="cloud-download"
                  loading={consultandoSefaz}
                  disabled={!emitenteNFeSelecionado || carregandoEmitentesNFe}
                  onClick={this.onConsultarSefazNFe}
                  style={{ width: '100%' }}
                >
                  Consultar por NSU
                </Button>
              </Col>
            </Row>

            <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 12, marginTop: 4, marginBottom: 12 }}>
              <Row gutter={12}>
                <Col xs={24} md={16}>
                  <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Chave de acesso da NF-e</div>
                  <Input
                    value={chaveConsultaSefaz}
                    maxLength={44}
                    placeholder="Informe os 44 dígitos da chave"
                    onChange={event => this.setState({
                      chaveConsultaSefaz: String(event.target.value || '').replace(/\D/g, '').substring(0, 44)
                    })}
                    onPressEnter={this.onConsultarSefazPorChave}
                  />
                  <div style={{ marginTop: 4, color: 'rgba(0,0,0,.45)', fontSize: 12 }}>
                    Consulta pontual por chave. Não altera o último NSU da distribuição sequencial.
                  </div>
                </Col>

                <Col xs={24} md={8} style={{ paddingTop: 24 }}>
                  <Button
                    type="default"
                    icon="search"
                    loading={consultandoSefaz}
                    disabled={!emitenteNFeSelecionado || carregandoEmitentesNFe || String(chaveConsultaSefaz || '').length !== 44}
                    onClick={this.onConsultarSefazPorChave}
                    style={{ width: '100%' }}
                  >
                    Consultar por Chave
                  </Button>
                </Col>
              </Row>
            </div>

            {emitenteSelecionado ? (
              <div style={{ marginBottom: 12 }}>
                <Tag color={Number(emitenteSelecionado.enf_ambiente) === 2 ? 'orange' : 'green'}>
                  {Number(emitenteSelecionado.enf_ambiente) === 2 ? 'Homologação' : 'Produção'}
                </Tag>
                <Tag>{emitenteSelecionado.cuf_sigla || '-'} / cUF {emitenteSelecionado.cuf_codigo || '-'}</Tag>
                <Tag color={emitenteSelecionado.certificado_local ? 'green' : 'red'}>
                  {emitenteSelecionado.certificado_local ? 'Certificado local OK' : 'Certificado local não encontrado'}
                </Tag>
                {emitenteSelecionado.enf_data_certificado ? (
                  <Tag>Validade: {moment(emitenteSelecionado.enf_data_certificado).format('DD/MM/YYYY')}</Tag>
                ) : null}
              </div>
            ) : null}

            {retornoSefaz ? (
              <div style={{ marginBottom: 12 }}>
                <Tag color={retornoSefaz.tipo_consulta === 'chave' ? 'blue' : 'geekblue'}>
                  {retornoSefaz.tipo_consulta === 'chave' ? 'Consulta por chave' : 'Consulta por NSU'}
                </Tag>
                <Tag>cStat: {retornoSefaz.cStat}</Tag>
                {retornoSefaz.tipo_consulta !== 'chave' ? (
                  <React.Fragment>
                    <Tag>ultNSU: {retornoSefaz.ultNSU || '-'}</Tag>
                    <Tag>maxNSU: {retornoSefaz.maxNSU || '-'}</Tag>
                  </React.Fragment>
                ) : null}
                <span style={{ marginLeft: 8 }}>{retornoSefaz.xMotivo}</span>
              </div>
            ) : null}

            {notasSefaz.length > 1 ? (
              <Select
                style={{ width: '100%', marginBottom: 12 }}
                placeholder="Selecione a NF-e que deseja importar"
                onChange={this.onSelecionarNotaSefaz}
                showSearch
                optionFilterProp="children"
              >
                {notasSefaz.map(nota => (
                  <Option key={nota.chave} value={nota.chave}>
                    {`NF-e ${nota.numero} - ${nota.fornecedor ? nota.fornecedor.pes_nome : ''} - R$ ${numeral(Number(nota.totais && nota.totais.vNF || 0)).format('0,000.00')}`}
                  </Option>
                ))}
              </Select>
            ) : null}

            {resumosSefaz.length > 0 ? (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12 }}
                message={`${resumosSefaz.length} documento(s) retornaram somente como resumo`}
                description="Esses documentos ainda não vieram com o XML completo (procNFe) nesta distribuição; por isso não são liberados para importar itens nesta tela."
              />
            ) : null}
          </TabPane>
        </Tabs>

        {(importandoXml || consultandoSefaz) ? (
          <div style={{ textAlign: 'center', padding: 30 }}>
            <Spin size="large" />
          </div>
        ) : null}

        {notaImportacao ? (
          <div>
            <Divider />
            <Row gutter={12} style={{ marginBottom: 12 }}>
              <Col xs={24} md={8}>
                <strong>NF-e:</strong> {notaImportacao.numero || '-'} / Série {notaImportacao.serie || '-'}
              </Col>
              <Col xs={24} md={8}>
                <strong>Emissão:</strong> {notaImportacao.dataEmissao ? moment(notaImportacao.dataEmissao).format('DD/MM/YYYY HH:mm') : '-'}
              </Col>
              <Col xs={24} md={8}>
                <strong>Total:</strong> R$ {numeral(Number(notaImportacao.totais && notaImportacao.totais.vNF || 0)).format('0,000.00')}
              </Col>
            </Row>

            <Row style={{ marginBottom: 12 }}>
              <Col xs={24}>
                <strong>Fornecedor:</strong>{' '}
                {notaImportacao.fornecedor ? notaImportacao.fornecedor.pes_nome : '-'}{' '}
                {notaImportacao.fornecedor && notaImportacao.fornecedor.documento ? `(${notaImportacao.fornecedor.documento})` : ''}
                {' '}
                {fornecedorOk ? <Tag color="green">Localizado</Tag> : <Tag color="orange">Será cadastrado automaticamente</Tag>}
              </Col>
            </Row>

            {!fornecedorOk ? (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12 }}
                message="Fornecedor ainda não cadastrado"
                description="Ao continuar, o FastGestor cadastrará automaticamente este fornecedor em Pessoas usando os dados do XML e seguirá com a importação da compra."
              />
            ) : null}

            {notaImportacao.destinatario
              && notaImportacao.destinatario.documento
              && !notaImportacao.destinatario.emitente_localizado ? (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12 }}
                message="NF-e destinada a outro CNPJ/CPF"
                description={
                  `O destinatário informado no XML é ${notaImportacao.destinatario.nome || 'não informado'} (${notaImportacao.destinatario.documento}). `
                  + 'Esse documento não corresponde a nenhum emitente cadastrado para a empresa logada. Você pode continuar a importação se desejar.'
                }
              />
            ) : null}

            {notaImportacao.ja_cadastrada ? (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12 }}
                message="Esta NF-e já foi cadastrada"
                description={(() => {
                  const compra = notaImportacao.compra_existente || {};
                  const partes = [`Chave: ${notaImportacao.chave || '-'}.`];
                  if (compra.com_numero) partes.push(`Compra nº ${compra.com_numero}.`);
                  if (compra.pes_nome) partes.push(`Fornecedor: ${compra.pes_nome}.`);
                  if (compra.com_dt_compra) partes.push(`Data da compra: ${moment(compra.com_dt_compra).format('DD/MM/YYYY')}.`);
                  partes.push('A importação permanece liberada.');
                  return partes.join(' ');
                })()}
              />
            ) : null}

            <Table
              dataSource={itens}
              rowKey={(item, index) => `${item.nItem || index}-${item.cProd}`}
              pagination={false}
              size="small"
              scroll={{ x: 1250, y: 360 }}
              bordered
            >
              <Column title="Item Forn." dataIndex="cProd" width={90} />
              <Column title="Cód. Barras" dataIndex="cEAN" width={125} />
              <Column title="Descrição do XML" dataIndex="xProd" width={240} />
              <Column title="NCM" dataIndex="NCM" width={80} />
              <Column title="CFOP" dataIndex="CFOP" width={70} />
              <Column title="Qtde" dataIndex="qCom" width={70} align="right" />
              <Column
                title="Vlr. Unit."
                dataIndex="vUnCom"
                width={95}
                align="right"
                render={value => numeral(Number(value || 0)).format('0,000.00')}
              />
              <Column
                title="Total"
                dataIndex="vTotal"
                width={95}
                align="right"
                render={value => numeral(Number(value || 0)).format('0,000.00')}
              />
              <Column
                title="Produto FastGestor"
                width={330}
                render={(text, item, index) => (
                  <div>
                    <Select
                      showSearch
                      allowClear
                      value={item.prod_idf ? String(item.prod_idf) : undefined}
                      placeholder="Digite código, descrição ou código de barras"
                      filterOption={false}
                      onSearch={this.onBuscarProdutoImportacao}
                      onChange={value => value ? this.onVincularProdutoImportacao(index, value) : null}
                      notFoundContent={buscandoProdutosImportacao ? <Spin size="small" /> : 'Digite ao menos 2 caracteres'}
                      style={{ width: '100%' }}
                    >
                      {item.prod_idf ? (
                        <Option key={`atual-${item.prod_idf}`} value={String(item.prod_idf)}>
                          {`${item.prod_codigo || ''} - ${item.prod_descricao || ''}`}
                        </Option>
                      ) : null}
                      {(produtosImportacao || [])
                        .filter(prod => String(prod.prod_idf) !== String(item.prod_idf || ''))
                        .map(prod => (
                          <Option key={prod.prod_idf} value={String(prod.prod_idf)}>
                            {`${prod.prod_codigo} - ${prod.prod_descricao}${prod.prod_cod_barras ? ` - ${prod.prod_cod_barras}` : ''}`}
                          </Option>
                        ))}
                    </Select>
                    <div style={{ marginTop: 4 }}>
                      {this.renderStatusVinculo(item)}
                      {Number(item.prod_grade || 0) === 1 && Number(item.qtde_variacoes || 0) > 1 ? (
                        <Tag color="orange">Possui grade - revisar tamanho/cor</Tag>
                      ) : null}
                    </div>
                  </div>
                )}
              />
            </Table>

            <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <span>
                <strong>{itens.filter(item => !!item.prod_idf).length}</strong> de <strong>{itens.length}</strong> itens vinculados
              </span>
              <span>
                <strong>Chave:</strong> {notaImportacao.chave || '-'}
              </span>
            </div>
          </div>
        ) : null}
      </Modal>
    );
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: String(this.state.filtros.buscaUsuario),
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderSitFinanc = (tit_situacao) => {
    return (
      <span> {tit_situacao === 'P' ? 'PAGO' : 'ABERTO'} </span>
    );
  };

  renderUsuario = (usu_nome) => {
    return (
      <span>{usu_nome.substring(0, 10)}</span>
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('ComprasPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('ComprasPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
        <span>
          <Tooltip title="Impressão">
            <Button type="ghost" size="small" onClick={() => this.onImprimirClick(registro.com_idf)} icon="printer" />
          </Tooltip>
        </span>
      </ButtonGroup>
    );
  };

  renderValor = (com_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(com_vlr_total)).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, formPrintVisivel, total, pagina, limite } = this.state;

    // console.log('ComprasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Gerenciar Compras</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              className="botao-ajuda"
            ></Button>
          </Tooltip>
        </div>
        <div className="divider-page" />

        <div className="pageFiltro" style={{ height: 50, paddingTop: 10 }}>
          <Col xs={24} >
            <Col xs={9}>
              {getTemPermissao('ComprasPage', 'novo') ? (
                <Col xs={2} style={{ width: 110 }}>
                  <Button
                    type="primary"
                    onClick={this.onAdicionarClick}
                    className="botao-primary"
                  >
                    Adicionar
                  </Button>
                </Col>
              ) : null}

              {getTemPermissao('ComprasPage', 'novo') ? (
                <Col xs={2} style={{ width: 175 }}>
                  <Button
                    type="primary"
                    icon="file-add"
                    onClick={this.onAbrirImportacaoNFe}
                    className="botao-primary"
                    style={{ width: 150 }}
                  >
                    Importar NF-e
                  </Button>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              {/* <Col xs={2} style={{ width: 110 }}>
                <PedidosPrintModal
                  filtros={filtros}
                  totalCompras={this.state.totalCompras}
                  qtdeCompras={this.state.qtdeCompras}
                />
              </Col> */}

              <PedidoFiltroForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />
            </Col>

            <Col xs={24} md={8} style={{ height: 65, padding: 5, marginTop: -25 }}>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde Compras
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeCompras}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Total Compras
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalCompras)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>

            {/* <Col xs={24} sm={7} style={{ background: Colors.background, padding: 5, marginTop: -10 }}>
              <Col xs={24} sm={11} style={{ marginRight: 5, textAlign: "center", background: "white", marginLeft: 5 }} >
                <Row><span style={{ fontWeight: "bold" }}>Qtde Compras</span></Row>
                <Row><span>{this.state.qtdeCompras}</span></Row>
              </Col>
              <Col xs={24} sm={12} style={{ marginRight: 0, textAlign: "center", background: "white" }} >
                <Row><span style={{ fontWeight: "bold" }}>Total Compras</span></Row>
                <Row><span>R$ {this.renderValor(this.state.totalCompras)}</span></Row>
              </Col>
            </Col> */}
          </Col>

          {this.renderImportacaoNFeModal()}

          <CompraForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <CompraPrintModal
            visivel={formPrintVisivel}
            com_idf={this.state.idfCompra}
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

          <Compras
            isOpen={this.state.modalOpen}
            onClose={() => this.setState({ modalOpen: false })}
          />
        </div>



        <div style={{ paddingTop: 0 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.com_idf)}
          >
            <Column
              key="com_numero"
              dataIndex="com_numero"
              title={this.renderTitulo("Número")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="com_dt_compra"
              dataIndex="com_dt_compra"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={120}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Fornecedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={200}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="com_vlr_total"
              dataIndex="com_vlr_total"
              title={this.renderTitulo("Valor Total")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Usuário")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={100}
              align="center"
              className="listaCadastro"
              render={this.renderUsuario}
            />
            <Column
              key="tit_situacao"
              dataIndex="tit_situacao"
              title={this.renderTitulo("Sit. Financ.")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderSitFinanc}
              width={100}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={70}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ComprasPage.js